(function (window, document) {
  function isCartPage() {
    return document.body && (
      document.body.classList.contains('cart') ||
      window.location.pathname === '/cart' ||
      window.location.pathname.indexOf('/cart/') === 0
    );
  }

  function disableLazyMotion() {
    if (isCartPage()) return;

    document.querySelectorAll('img[loading="lazy"], iframe[loading="lazy"]').forEach(function (element) {
      element.setAttribute('loading', 'eager');
    });

    document.querySelectorAll('[data-aos]').forEach(function (element) {
      element.classList.add('aos-init', 'aos-animate');
      element.removeAttribute('data-aos');
      element.removeAttribute('data-aos-easing');
      element.removeAttribute('data-aos-duration');
      element.removeAttribute('data-aos-delay');
      element.removeAttribute('data-aos-once');
    });

    document.querySelectorAll('.container, .effect__circle, .product-media-container, [data-inview], .in-view').forEach(function (element) {
      element.classList.add('is-active');
    });
  }

  window.TruNutraDisableLazyMotion = disableLazyMotion;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableLazyMotion);
  } else {
    disableLazyMotion();
  }
})(window, document);
